// /** @module maps/leaflet */
import {BaseMap} from "./map_base";
import {getUrl} from "../main_ptx";

/**
 * @alias Ptx.maps.OSM
 */
export const LeafletMap = BaseMap.extend(
		/** @lends module:maps/leaflet */
		{
			clusterOpts: {
				//KEYs for this clusterOpts are the same as Ptx.maps.TYPE_ constants, as defined in maps_base
				//this is used to define different cluster options for different map types
				'TYPE_MAIN': {
					'general': {},
					'vehicle': {disableClusteringAtZoom: 12},
					'tp': {
						disableClusteringAtZoom: 14,
						maxClusterRadius: 12,
						showCoverageOnHover: false,
						iconCreateFunction: function (cluster) {
							var childCount = cluster.getChildCount();

							var c = ' marker-cluster-';
							if (childCount < 10) {
								c += 'small';
							} else if (childCount < 20) {
								c += 'medium';
							} else {
								c += 'large';
							}
							return new L.DivIcon({
								html: '<div><span>' + childCount + '</span></div>',
								className: 'marker-tp-cluster' + c,
								iconSize: new L.Point(20, 20)
							});

						}
					},
					'poi-circle': {
						disableClusteringAtZoom: 12,
						iconCreateFunction: function (cluster) {
							return L.divIcon({
								html: '',
								className: 'marker-cluster marker-cluster-poi',
								iconSize: new L.Point(40, 40)
							});
						}
					},
					'poi-marker': {
						disableClusteringAtZoom: 12,
						iconCreateFunction: function (cluster) {
							return L.divIcon({
								html: '<div><span><b>' + cluster.getChildCount() + '</b></span></div>',
								className: 'marker-cluster marker-cluster-poi',
								iconSize: new L.Point(40, 40)
							});
						}
					},
					'geozone-circle': {
						disableClusteringAtZoom: 12,
						iconCreateFunction: function (cluster) {
							return L.divIcon({
								html: '',
								className: 'marker-cluster marker-cluster-poi',
								iconSize: new L.Point(40, 40)
							});
						}
					},
					'geozone-marker': {
						disableClusteringAtZoom: 12,
						iconCreateFunction: function (cluster) {
							return L.divIcon({
								html: '<div><span><b>' + cluster.getChildCount() + '</b></span></div>',
								className: 'marker-cluster marker-cluster-poi',
								iconSize: new L.Point(40, 40)
							});
						}
					},
				},
				'TYPE_LOGBOOK': {
					'general': {},
					'vehicle': {disableClusteringAtZoom: 12},
					'tp': {
						disableClusteringAtZoom: 14,
						maxClusterRadius: 12,
						showCoverageOnHover: false,
						iconCreateFunction: function (cluster) {
							var childCount = cluster.getChildCount();

							var c = ' marker-cluster-';
							if (childCount < 10) {
								c += 'small';
							} else if (childCount < 20) {
								c += 'medium';
							} else {
								c += 'large';
							}
							return new L.DivIcon({
								html: '<div><span>' + childCount + '</span></div>',
								className: 'marker-tp-cluster' + c,
								iconSize: new L.Point(20, 20)
							});
						}
					}
				},
				'TYPE_SIMPLE': {
					'general': {},
					'vehicle': {disableClusteringAtZoom: 12},
					'tp': {showCoverageOnHover: false}
				},
				'TYPE_EOD': {
					'general': {},
					'tp': {disableClusteringAtZoom: 12}
				}
			},
			/*
				GeoJSON geometries style
			*/
			geoJsonStyleOpts: {
				'trip': {
					color: '#00AAFF',
					weight: 5,
					fillColor: '#00AAFF',
					fillOpacity: 0.8
				},
				'trip-fake': {
					color: '#00AAFF',
					weight: 5,
					opacity: 0.5,
					dashArray: '20,15'
				},
				'DEFAULT': {
					color: '#9B53C3',
					weight: 0,
					opacity: 0.25
				}
			},

			//redefined constants
			currentPoint: null,
			gjDataLayer: null, //geojson data layer holder for non modified geojson objects
			maxDefaultZoom: 15,
			currentInfoBox: null, //currently opened infobox for window


			constructor: function (mapContainer, opts, mapSettings) {
				this.name = "LEAF";
				this.base(mapContainer, opts, mapSettings);
			},
			/**
			 * Defines layers for OSM maps
			 */
			getLayers: function () {
				var l = [];
				l.push(L.tileLayer(''));
				return l;
			},

			createLayers: function () {
				var self = this,
						baseMaps = {},
						obj, basic, grayscale, rail, railSpeed;

				obj = self.getLayers();
				var map_settings = document.querySelector(".map-settings");

				// Define base layers
				basic = Ptx.maps.OSM.defineMap(obj.code, L.tileLayer, obj.serverBase);
				baseMaps[Ptx.getMsg('map.layer.basic')] = basic;

				grayscale = Ptx.maps.OSM.defineMap(obj.code, L.tileLayer.grayscale, obj.serverBase);
				baseMaps[Ptx.getMsg('map.layer.grayscale')] = grayscale;

				if (self.mapSettings &&
						self.mapSettings.hasOwnProperty("overlays") &&
						self.mapSettings.overlays.includes("RAILWAY")) {

					rail = L.layerGroup([
						Ptx.maps.OSM.defineMap(obj.code, L.tileLayer.grayscale, obj.serverBase),
						Ptx.maps.OSM.defineMap("rail", L.tileLayer, obj.serverBase)
					]);
					baseMaps[Ptx.getMsg('map.layer.rail')] = rail;

					railSpeed = L.layerGroup([
						Ptx.maps.OSM.defineMap(obj.code, L.tileLayer.grayscale, obj.serverBase),
						Ptx.maps.OSM.defineMap("railspeed", L.tileLayer, obj.serverBase)
					]);
					baseMaps[Ptx.getMsg('map.layer.railspeed')] = railSpeed;
				}

				// Create the layer control
				var control = L.control.layers(baseMaps);
				control.addTo(self.map);

				// Check storage for saved layer selection
				var savedLayer = Ptx.fn.getSession('selectedLeafletLayer') || Ptx.getMsg('map.layer.basic');

				// Apply the saved layer initially
				if (baseMaps[savedLayer]) {
					baseMaps[savedLayer].addTo(self.map);
				} else {
					basic.addTo(self.map); // Fallback to basic layer
				}

				// Save the selected layer to storage when changed
				self.map.on('baselayerchange', function(e) {
					Ptx.fn.setSession('selectedLeafletLayer', e.name);
				});

				// Insert the control into the map settings container
				if (map_settings) map_settings.insertBefore(control.getContainer(), map_settings.firstChild);
			},

			/** @see maps/base#create */
			create: function (mapContainer, opts, mapSettings) {
				this.base(mapContainer, opts, mapSettings);
				this.createLeaflet(mapContainer, opts);
			},

			/**
			 * Enables polygon drawing on a Leaflet instance and handles the drawn polygons.
			 */
			enablePolygonDrawing: function (sendPolygonData) {
				var self = this;
				if (!self.drawnItems) {
					self.drawnItems = new L.FeatureGroup();
					self.map.addLayer(self.drawnItems);
					self.editToolList = {};
				}

				// Remove existing polygons
				self.drawnItems.clearLayers();

				if (!self.editToolList.polygon) {
					self.editToolList.polygon = new L.Draw.Polygon(self.map, {
						allowIntersection: false,
						drawError: {
							color: '#b00b00',
							timeout: 1000
						},
						shapeOptions: {
							color: '#3388ff',
							weight: 4
						},
						edit: {
							featureGroup: self.drawnItems
						}
					});
				}
				self.editTool = self.editToolList.polygon;

				// Remove the previous 'draw:created' event listener before adding a new one
				self.map.off('draw:created');
				self.map.on('draw:created', function (e) {
					var layer = e.layer;
					self.drawnItems.clearLayers();
					self.drawnItems.addLayer(layer);

					var polygonCoordinates = layer.getLatLngs()[0].map(function (latLng) {
						return [latLng.lng, latLng.lat]; // Note: Longitudes come before latitudes in GeoJSON
					});

					// Duplicate the first point and add it at the end to form a closed ring and send the full polygon to the server
					polygonCoordinates.push(polygonCoordinates[0]);
					sendPolygonData(polygonCoordinates);
				});
				self.editTool.enable();
			},

			/** create this map by documented google way, using jsonp callback and direct url specification */
			createLeaflet: function (mapContainer, opts) {

				function loadMainApi(callback) {
					if (typeof window.L === "undefined") {
						$.getScript(getUrl('/res/dist/js/leaflet.js?_ts='+Ptx.buildInfoHash), function () {
							loadLibs(callback);
						});
					} else {
						callback(); //asume if leaflet API is present, then all libs are present as well
					}
				}

				//load additional libraries
				function loadLibs(callback) {
					$.when(
						$.getScript(getUrl("/res/dist/js/leaflet_bundle.js?_ts="+Ptx.buildInfoHash)),
						$.Deferred(function (deferred) {
							$(deferred.resolve);
						})
					).done(callback);
				}

				var self = this;
				loadMainApi(function () {
					self.map = L.map(mapContainer, { /*drawControlTooltips: false - nezobrazuje tooltipy}*/
						fullscreenControl: true,
						fadeAnimation: false, //removes flickering with grayish tile layer when moving, see L.tileLayer.grayscale comment
						fullscreenControlOptions: {
							position: 'topleft'
						}
					});
					self.map.setView([50, 16], 4);
				
					//TODO store these layers and add ability to remove (switch to rail map require removing old layer and adding new grayish one and overlay one)
					var lyrs = self.getLayers().layers;
					for (var l in lyrs) {
						lyrs[l].addTo(self.map);
					}
					self.ready = true;
					self.clusters = {};
					self.clearClusters(true);
					self.geoBounds = new L.LatLngBounds();
					self.heatTp = L.heatLayer([], {radius:20}); // .addTo(self.map);
					L.Icon.Default.imagePath = getUrl("/res/dist/images/");

					//define what type of map should be prepared
					self.findMapCreatorFunction_();
					//for inherited classes is there way to init some map shits by themselves
					if (typeof self.internalMapInit == 'function') {
						self.internalMapInit(self);
					}

					if (opts.initCallback)
						opts.initCallback(self);

					self.createLayers();
					L.control.scale({ metric: true, imperial: false }).addTo(self.map);
				});
			},

			/** @see maps/base#showTpAfterZoom_ */
			showTpAfterZoom: function () {
//	  var self = this;
//		zoomLevel = self.map.getZoom();
//	    var clusters = self.clusters['tp'].clusters_;
//	    for (var i = 0; i < clusters.length; i++) {
//	    	if (zoomLevel < self.showTpDefaultZoom) {
//	    		clusters[i].clusterIcon_.className_ += " hidden";
//	    	}
//	    }
			},


			/** @see maps/base#unloadMap */
			destroy: function () {
				this.map = null;
				this.visibleUnits = null;
				this.poi = [];
				this.geos = [];
				this.geozone = [];
				this.geoJson = null;
				this.geoBounds = null;
			},

			resize: function () {
				this.map.invalidateSize();
				this.gjDataShowBounds();
			},

			/** @see maps/base#centerAndZoom */
			centerAndZoom: function (lat, lon, zoom) {
				this.map.setView(new L.LatLng(lat, lon), zoom);
				/*this.map.panTo({lon: lon, lat: lat});
				this.map.setZoom(zoom);*/
			},
			/** @see maps/base#zoom */
			zoom: function (zoom) {
				this.map.setZoom(zoom);
			},

			/** @see maps/base#setZoom */
			setZoom: function (zoom) {
				this.zoom(zoom);
			},

			/** @see maps/base#getZoom */
			getZoom: function () {
				return this.map.getZoom();
			},

			/** @see maps/base#setLatLon */
			setLatLng: function (latlng) {
				this.map.panTo(latlng);
			},

			/** @see maps/base#getLatLon */
			getLatLng: function () {
				var center = this.map.getCenter();
				return {lat: center.lat, lng: center.lng};
			},

			/** @see maps/base#positionChanged */
			positionChanged: function (callback) {
				this.map.on('moveend', callback);
			},

			/** @see maps/base#fitStrBounds */
			fitStrBounds: function (bounds) {
				var points = points = this.parsePoints(bounds);
				var bounds = new L.LatLngBounds();
				for (var i = 0; i < points.length; i++) {
					bounds.extend(new L.LatLng(points[i].lat, points[i].lon));
				}

				this.map.fitBounds(bounds);
			},

			/** @see maps/base#gjDataShow */
			gjDataShow: function (geoJsonData, afterLoadCallback) {
				this.base(geoJsonData, afterLoadCallback);
				var self = this;
				var map = self.map;

				self.gjDataLayer = L.geoJson(geoJsonData, {
					onEachFeature: self.onEachFeature,
					style: function (feature) {
						var style = self.getStyleForFeature(feature.properties ? feature.properties.type : null);
						feature.properties.color ? style.color = feature.properties.color : null;
						return style;
					}
				})

				if (self.opts?.mapType === "TYPE_SIMPLE") {	// only add to the map if it's a simple map, because we handle features for other maps separately
					self.gjDataLayer.addTo(map);
				}

				self.gjDataLayer.eachLayer(function (l) {
					if (l.feature.removeFromLayer) {
						self.gjDataLayer.removeLayer(l);
					}
				});
				if (typeof afterLoadCallback === 'function') {
					afterLoadCallback();
				} else {
					self.gjDataShowBounds();

				}
				this.markerToggleClusters();
				this.markerShowLabels('ALL');
			},

			/** @see maps/base#gjDataShowBounds */
			gjDataShowBounds: function (zoom, autofocus, autozoom) {
				var self = this;
				var map = this.map;
				var isAutofocus = self.autofocus === true || (typeof autofocus !== "undefined" && autofocus === true);
				var isAutozoom = self.autozoom === true || (typeof autozoom !== "undefined" && autozoom === true);
				var isZoom = typeof zoom != 'undefined' && zoom != null;
				if (isAutofocus) {
					if (self.geoBounds && self.geoBounds.isValid()) {
						if (isAutozoom) {
							Ptx.fn.delay(400, function () {
								map.fitBounds(self.geoBounds, {maxZoom: self.maxDefaultZoom});
							})
						} else {
							map.panTo(self.geoBounds.getCenter());
						}
					}
					if (isZoom) {
						map.setZoom(zoom);
					} else {
						if (!isAutozoom) {
							var mapPosition = Ptx.fn.getSession("mapPosition");
							map.setZoom(mapPosition ? mapPosition.zoom : 12);
						} else {
							if (self.maxDefaultZoom < map.getZoom()) {
								map.setZoom(self.maxDefaultZoom);
							}
						}
					}
				}
			},


			/** @see maps/base#gjDataHide */
			gjDataHide: function (clearPOI) {
				//uncache pois and geozones
				this.base(clearPOI);
				var self = this;
				//remove pure geojson object
				if (self.gjDataLayer) {
					self.gjDataLayer.clearLayers();
				}

				//remove markers from cluster
				this.clearClusters(clearPOI);
				this.geoBounds = new L.LatLngBounds();

				this.geos = [];
				this.clusters['geozone-circle'].clearLayers();
				this.clusters['geozone-marker'].clearLayers();
			},

			/**
			 * @see maps/base#markerToggleClusters
			 */
			markerToggleClusters: function (showClusters) {
				// cache showClusters
				this.base(showClusters);
				var self = this;
				var map = self.map;

				/**
				 * Recreate cluster with new settings of clustering max zoom
				 */
				function replaceCluster(clName) {
					//clone original options, is is pretty fast according to http://heyjavascript.com/4-creative-ways-to-clone-objects/
					//var opts = (JSON.parse(JSON.stringify(self.clusterOpts[self.opts.mapType][clusterName])));

					var cl = self.clusters[clName];
					if (cl != undefined) {
						var defOpts = self.clusterOpts[self.opts.mapType][clName];
						var opts = $.extend({}, defOpts);
						//"Hack" for disabling clusters
						if (typeof self.showClusters !== "undefined" && self.showClusters === false) {
							opts.disableClusteringAtZoom = 1;
						}
						var newCl = new L.MarkerClusterGroup(opts);
						newCl.addLayers(cl.getLayers());
						map.removeLayer(cl);
						newCl.addTo(map);
						self.clusters[clName] = newCl;
					}
				}

				replaceCluster('vehicle');
				replaceCluster('poi-circle');
				replaceCluster('poi-marker');
				replaceCluster('geozone-circle');
				replaceCluster('geozone-marker');
				replaceCluster('tp');
				this.markerShowLabels('ALL');
			},

			/**
			 * @see maps/base#togglePoi
			 */
			togglePoi: function (showPoi) {
				var self = this
				this.base(showPoi)

				function editLayer(clusterName, poiArray) {
					if (self.showPoi == true) {
						poiArray.forEach(function (item) {
							self.clusters[clusterName].addLayer(item);
						});
					} else {
						self.clusters[clusterName].clearLayers();
					}

				}

				editLayer('poi-circle', this.poi);
				editLayer('poi-marker', this.poi);
			},

			toggleGeozone: function (showGeozone) {
				var self = this
				this.base(showGeozone)

				function editLayer(clusterName, geoArray) {
					if (self.showGeozone == true) {
						geoArray.forEach(function (item) {
							self.clusters[clusterName].addLayer(item);
						});
					} else {
						self.clusters[clusterName].clearLayers();
					}

				}

				editLayer('geozone-circle', this.geos);
				editLayer('geozone-marker', this.geos);
			},

			/**
			 * Clear all clusters and remove all markers
			 */
			clearClusters: function (removePOI) {
				var self = this;

				function clear(name) {
					if (self.clusters[name]) self.clusters[name].clearLayers();
					self.clusters[name] = new L.MarkerClusterGroup(self.clusterOpts[self.opts.mapType][name]);
					self.map.addLayer(self.clusters[name]);
				}

				if (typeof self.clusters == 'undefined') {
					self.clusters = {};
				}
				clear('vehicle');
				clear('general');
				clear('tp');
				if (typeof removePOI != "undefined" && removePOI == true) {
					clear('poi-circle');
					clear('poi-marker');
					clear('geozone-circle');
					clear('geozone-marker');
				}

				for (var btsIndex = 0, btsSize = self.bts.length; btsIndex < btsSize; btsIndex++) {
					self.bts[btsIndex].removeFrom(self.map);
				}
				self.bts = [];
			},


			playAnimatedMarker: function (vehicle) {
				var self = this;
				if (self.AM) {
					self.AM.start();
				} else {
					self.AM = new AnimatedMarker.leaflet;
					self.createAnimatedMarker(vehicle);
					self.AM.start();
				}
			},


			/**
			 * Tools for creating vehicles, points etc.
			 */
			creators: {

				createFeature: function (self, feat) {
					if (feat.geometry.type == 'Point') {
						self.creators.createGeoPoint(self, feat);
						return true;
					}
					return false;
				},


				/**
				 * Get position from geometry
				 */
				getPosition: function (g) {
					return new L.LatLng(g.coordinates[1], g.coordinates[0])
				},
				/**
				 * Create all available types of points (vehicle, tp, eod, poi)
				 */
				createGeoPoint: function (self, feat) {
					var t = feat.properties['type'];
					if (t == 'vehicle') {
						self.creators.createVehicle(self, feat);
					} else if (t == 'POI') {
						self.creators.createPOI(self, feat);
					} else if (t == 'BTS') {
						self.creators.createBTS(self, feat);
					} else if (t == 'GPSD') {
						self.creators.createGPSD(self, feat);
					} else if (t == 'trackBreak') {
						self.creators.createTrackBreak(self, feat);
					} else if (t == 'report') {
						self.creators.createReportTp(self, feat);
					} else if (t.startsWith('tp_')) {
						self.creators.createTp(self, feat);
					} else if (t == 'gz') {
						self.creators.createGeozone(self, feat);
					}
				},
				/**
				 * Create trip LineString
				 */
				createLineString: function(self, feat) {
					var type = feat.properties['type'];
					if (type === 'trip') {
						var lineSymbol = self.getStyleForFeature(type);
						lineSymbol.strokeColor = feat.properties['color'];
						lineSymbol.strokeOpacity = 1;

						var latlngs = feat.geometry.coordinates.map(function(coord) {
							return [coord[1], coord[0]];
						});

						var polyline = L.polyline(latlngs, {
							color: lineSymbol.strokeColor,
							opacity: lineSymbol.strokeOpacity,
							weight: 5,
						}).addTo(self.map);
					}
				},
				/**
				 * Create POI
				 */
				createPOI: function (self, feat) {
					var name = feat.properties['name'];
					var radius = feat.properties['radius'];
					var center = self.creators.getPosition(feat.geometry);

					var labelClass = 'label-poi'
					if (self.showPoiLabels == false) {
						labelClass = 'label-poi hidden'
					}

					var cssIcon = L.divIcon({
						className: '',
						iconAnchor: [6, 30],
						iconSize: null, //take size by content!!!
						html: '<img src="' + getUrl('/img/u/map/poi_small.png') + '" class="abs"><div class="' + labelClass + ' float-left" style="margin-left:15px;">' + name + '</div>'
					});
					var marker = L.marker(center, {icon: cssIcon})

					// marker.bindLabel(name).addTo(self.map);

					//feat.removeFromLayer = true;
					var circle = new L.Circle(center, radius, {
						color: '#9B53C3',
						weight: 0,
						fillColor: '#9B53C3',
						fillOpacity: 0.25
					});

					if (self.showPoi == true) {
						self.clusters['poi-circle'].addLayer(circle);
						self.clusters['poi-marker'].addLayer(marker);
					}

					self.poi.push(circle);
					self.poi.push(marker);
				},
				createGeozone: function (self, feat) {
					const name = feat.properties.name;
					const radius = feat.properties.radius;
					const gzType = feat.properties.gzType;

					const coorsInv = feat.geometry.geometries[0].coordinates[0]
						.map((it) => [it[1], it[0]]);
					const bounds = L.latLngBounds(coorsInv);
					const center = bounds.getCenter();

					let shape;

					const centerLat = L.latLngBounds(coorsInv).getCenter().lat;

					if(gzType === "POLYLINE") {
						const getPx = () => {
							const zoom = self.map.getZoom();
							const mpp  = 156543.03392 * Math.cos(centerLat * Math.PI/180)
									/ Math.pow(2, zoom);
							return radius / mpp;
						};

						shape = L.polyline(
								coorsInv,
								{
									color: feat.properties.color,
									opacity: 0.25,
									weight: getPx(),
									radiusMeters: radius,
									fillColor: feat.properties.color,
									fillOpacity: 0
								}
						);

						self.map.on('zoomend', () => {
							shape.setStyle({ weight: getPx() });
						});
					} else {
						shape = L.polygon(
								coorsInv,
								{
									color: '#9B53C3',
									weight: 0,
									fillColor: feat.properties.color,
									fillOpacity: 0.25
								}
						);
					}

					const labelClass = self.showPoiLabels ? 'label-geozone' : 'label-geozone hidden';

					const cssIcon = L.divIcon({
						className: '',
						iconAnchor: [6, 30],
						iconSize: null, //take size by content!!!
						html: `<img src="${getUrl('/img/u/map/poi_small.png')}" class="abs">
								  <div class="${labelClass} float-left" style="background-color:${feat.properties.color}; color:${self.getContrastColor(feat.properties.color)};margin-left:15px;">
									   ${name}
								   </div>`
					});

					const marker = L.marker(center, {icon: cssIcon})

					if (self.showGeozone == true) {
						self.clusters['geozone-circle'].addLayer(shape);
						self.clusters['geozone-marker'].addLayer(marker);
					}

					self.geos.push(shape);
					self.geos.push(marker);
				},

				/**
				 * Create POI (Point Of Interest)
				 */
				createBTS: function (self, feat) {
					var name = feat.properties['name'];
					var radius = feat.properties['radius'];
					var center = self.creators.getPosition(feat.geometry);

					var cssIcon = L.divIcon({
						className: '',
						iconAnchor: [0,0],
						iconSize: null, //take size by content!!!
						html: '<div class="label-bts">' + name + '</div>'
					});
					var marker = L.marker(center, {icon: cssIcon});

					// marker.bindLabel(name).addTo(self.map);

					//feat.removeFromLayer = true;
					var circle = new L.Circle(center, radius, {
						color: '#D44848',
						weight: 0,
						fillColor: '#D44848',
						fillOpacity: 0.17
					});

					marker.addTo(self.map);
					circle.addTo(self.map);

					self.bts.push(marker);
					self.bts.push(circle);
				},
				/**
				 * Create GPSD point
				 */
				createGPSD: function (self, feat) {
					var single = feat.properties['singleGpsd']; //is this only one GPSD, or is mixed within other TPs //TODO implement it?
					var addr = feat.properties['address'];
					var time = feat.properties['time'];

					var cssIcon = L.divIcon({
						className: 'label-vehicle',
						iconAnchor: [20, 48],
						iconSize: null, //take size by content!!!
						html: self.getVehicleMarker({
							ico: feat.properties['ico'], state: feat.properties['state'], color: feat.properties['color'], info: '',
							type: feat.properties['ico'], speed: feat.properties['speed']
						})
					});

					var p = self.creators.getPosition(feat.geometry);
					var contentId = 'info-window-unit' + feat.properties['unitId'];
					var title = self.getVehicleInfoBox({
						time: time, address: addr, domId: contentId, authorities: {}, hideButtonPanel: true
					});
					var marker = L.marker(p, {icon: cssIcon});
					marker.bindPopup(title);
					self.clusters['vehicle'].addLayer(marker);
					marker.on('popupopen', function () {
						if (Ptx.resolver) {
							var content = $('#' + contentId);
							Ptx.resolver.bulkResolve('trackPoint', content);
							Ptx.resolver.msgResolve(content);
						}
					});
				},
				/**
				 * Create track break trackpoint
				 */
				createTrackBreak: function (self, feat) {
					var addr = feat.properties['address'];
					var name = feat.properties['name'];
					var cssIcon = L.divIcon({
						className: 'label-vehicle',
						iconAnchor: [20, 48],
						iconSize: null, //take size by content!!!
						html: self.getVehicleMarker({
							ico: feat.properties['ico'],
							state: feat.properties['state'],
							name: feat.properties['name'],
							color: feat.properties['color'],
							info: '',
							type: feat.properties['ico'],
							speed: feat.properties['speed']
						})
					});
					var p = self.creators.getPosition(feat.geometry);
					var title = self.getTrackBreakInfoBox({
						name: feat.properties['name'],
						lat: feat.geometry.coordinates[1], lon: feat.geometry.coordinates[0], address: feat.properties['address']
					});

					var marker = L.marker(p, {icon: cssIcon});
					marker.bindPopup(title);
					self.clusters['tp'].addLayer(marker);
				},
				/**
				 * Create marker to cluster for vehicle
				 * @param feat Feature to create from
				 */
				createVehicle: function (self, feat) {
					var cssIcon = L.divIcon({
						className: 'label-vehicle',
						iconAnchor: [20, 48],
						iconSize: null, //take size by content!!!
						html: self.getVehicleMarker({
							ico: feat.properties['ico'],
							state: feat.properties['state'],
							name: feat.properties['label'],
							color: feat.properties['color'],
							displayDriverName: feat.properties['displayDriverName'],
							driver: feat.properties['driver'],
							info: '',
							type: feat.properties['ico'],
							speed: feat.properties['speed']
						})
					});

					var p = self.creators.getPosition(feat.geometry);
					var contentId = 'info-window-unit' + feat.properties['unitId'];
					var title = self.getVehicleInfoBox({
						unitId: feat.properties['unitId'],
						name: feat.properties['label'],
						time: feat.properties['time'],
						lat: feat.geometry.coordinates[1],
						lon: feat.geometry.coordinates[0],
						speed: feat.properties['speed'],
						address: feat.properties['address'],
						regPlate: feat.properties['registrationPlate'],
						domId: contentId,
						authorities: feat.properties['authorities'],
						driver: feat.properties['driver'],
						trackNote: feat.properties['trackNote']
					});
					var marker = L.marker(p, {icon: cssIcon});
					marker.bindPopup(title);
					self.clusters['vehicle'].addLayer(marker);
					marker.on('popupopen', function () {
						if (Ptx.resolver) {
							var ctx = $('#' + contentId);
							Ptx.resolver.bulkResolve('trackPoint', ctx);
							Ptx.resolver.msgResolve(ctx);
							Ptx.fn.initShowModal(ctx)
						}
					});

				}, //createVehicle


				/**
				 * Create animated marker
				 * @param feat Feature to create from
				 */
				createAnimatedVehicle: function (self, vehicle, latlon) {

					var cssIcon = L.divIcon({
						className: 'label-vehicle',
						iconAnchor: [20, 48],
						iconSize: null, //take size by content!!!
						html: self.getVehicleMarker(vehicle)
					});

					self.animatedMarker = L.marker(L.latLng(latlon['lat'], latlon['lon']), {icon: cssIcon}).addTo(self.map);

				},

				/**
				 * Create TP or EOD from feature
				 */
				createTp: function (self, feat) {
					const type = feat.properties['type'],
						state = feat.properties['state'],
						isRT41 = feat.properties['recordType'] === 41,
						position = self.creators.getPosition(feat.geometry),
						marker_info = getMarkerInfo();

					var marker = L.marker(position, {
						icon: L.icon({
							iconUrl: "/img/u/map/blank.png",
							className: "leaflet-sprite" + marker_info.name,
							iconAnchor: [8, 8],
						}),
						zIndexOffset: type === "tp_eod" ? 1000 : 0,
					});

					if (marker_info.icon === "arrow" && !marker_info.name.includes("warn")) {
						self.heatTp.addLatLng(L.latLng(position.lat, position.lng));
						marker.ptx = {time: feat.properties['time'], unixTime: feat.properties['unixTime']};
						self.clusters['tp'].addLayer(marker);
					} else {
						marker.addTo(self.map);
					}

					const tpContentId = 'info-window-tp-' + feat.properties['tpId'];
					const popup = self.getTpInfoBox({
						
						speed: feat.properties['speed'],
						address: feat.properties['address'],
						lat: feat.geometry.coordinates[1],
						lon: feat.geometry.coordinates[0],
						tpId: feat.properties['tpId'],
						time: feat.properties['time'],
						header1: feat.properties['header2'],
						header2: feat.properties['header1'],
						driver: feat.properties['driver'],
						domId: tpContentId
					});

					marker.bindPopup(popup);

					if (Ptx.fn.isMobile()) {
						marker.on('popupopen', function () {
							if (Ptx.resolver) {
								var tpContent = $('#' + tpContentId);
								Ptx.resolver.bulkResolve('trackPoint', tpContent);
								Ptx.resolver.msgResolve(tpContent);
							}
						});
					} else {
						marker.on('mouseover', function () {
							marker.openPopup();
							if (Ptx.resolver) {
								var tpContent = $('#' + tpContentId);
								Ptx.resolver.bulkResolve('trackPoint', tpContent);
								Ptx.resolver.msgResolve(tpContent);
							}
						});
						marker.on('mouseout', function () {
							marker.closePopup();
						});
					}

					function getMarkerInfo() {
						const rotation = feat.properties['course'], order = feat.properties['order'];
						var icon = "", name = "";

						if (state === "STOP") {
							icon = "point"; name = " leaflet-sprite--rest";
						} else if (state === "GLOBAL_START") {
							icon = "point"; name = " leaflet-sprite--start";
						} else if (state === "GLOBAL_STOP") {
							icon = "point"; name = " leaflet-sprite--stop";
						} else if (state === "FAKE_STOP") {
							icon = "point"; name = " leaflet-sprite--fake";
						} else if (order === 0) {
							icon = "arrow"; name = " leaflet-sprite--tp-circle";
						} else if (type === 'tp_eod' && !isRT41) {
							icon = "arrow"; name = " leaflet-sprite--tp-warn";
						} else if (type === 'tp_eod' && isRT41) {
							icon = "arrow";
							name = " leaflet-sprite--tp-rt-" + Math.floor(rotation / 30);
						} else {
							icon = "arrow";
							name = " leaflet-sprite--tp-order-" + order + "-deg-" + Math.floor(rotation / 30);
						}

						return { "icon": icon, "name": name };
					}
				}, //createTp
				/**
				 * Create heat points on TP locations
				 * @param self
				 * @param options object
				 */
				createHeatTp: function (self, options) {
					self.heatTp.addTo(self.map);
					if (typeof options === "object") {
						self.heatTp.setOptions(options);
					}
				},
				/**
				 * Create report TP
				 */
				createReportTp: function (self, feat) {

					var t = feat.properties['type'];
					var p = self.creators.getPosition(feat.geometry);
					var cssIcon = L.divIcon({
						className: 'label-vehicle',
						iconAnchor: [20, 48],
						iconSize: null, //take size by content!!!
						html: self.getVehicleMarker({
							ico: feat.properties['ico'],
							state: feat.properties['state'],
							name: feat.properties['name'],
							color: feat.properties['color'],
							info: '',
							type: feat.properties['ico']
						})
					});

					var marker = L.marker(p, {icon: cssIcon});
					self.clusters['tp'].addLayer(marker);
				}, //createreportTp

				/** create mark with car on map after click to chart */
				createPoint: function (self, vehicle, latlon) {
					if (self.currentPoint != null) {
						self.map.removeLayer(self.currentPoint);
					}

					var cssIcon = L.divIcon({
						className: 'label-vehicle',
						iconAnchor: [20, 48],
						iconSize: null, //take size by content!!!
						html: self.getVehicleMarker(vehicle)
					});

					self.currentPoint = L.marker(L.latLng(latlon['lat'], latlon['lon']), {icon: cssIcon}).addTo(self.map);
					self.centerAndZoom(latlon['lat'], latlon['lon'], self.map.zoom);
				}

			},

			/**
			 * Init behaviour on main Ptx map
			 */
			prepareMainMap: function () {
				var self = this;
				var map = this.map;

				self.onEachFeature = function (feat, layer) {
					var unitId = feat.properties['unitId'];
					var showUnit = ($.inArray(unitId, self.visibleUnits) > -1); //is unit visible = checked in table

					if (feat.geometry.type === 'Point') {
						var showPoint = showUnit || (feat.properties['type'] == 'POI'); //show POI

						if (showPoint) {
							self.creators.createFeature(self, feat);
							if (feat.properties['type'] == 'vehicle') {
								self.geoBounds.extend([feat.geometry.coordinates[1], feat.geometry.coordinates[0]]);
							}
						}
						feat.removeFromLayer = true;
					} else if (feat.geometry.type === 'GeometryCollection' && feat.properties.type === 'gz') {
						self.creators.createGeoPoint(self, feat);
					} else if (feat.geometry.type === 'LineString') {
						self.creators.createLineString(self, feat);
						// Show trip lines only for visible units, as these 'trips' are only few trackopints following
						// vehicle in motion.
						feat.removeFromLayer = !showUnit;
					}

					//is point

					layer.on('mouseover', function (e) {
						var title = e.target.feature.properties.name;
						self.showTooltipOnCursor(e, title);
					});

					layer.on('mouseout', function (e) {
						self.hideTooltipOnCursor();
					});

				}//onEachFeature

				self.onRightClickShowInsertPoi();

			},

			prepareSimpleMap: function () {
				var self = this;
				var map = this.map;
				var bounds = this.geoBounds;

				self.onEachFeature = function (feat, layer) {
					bounds.extend(layer.getBounds());
					map.fitBounds(bounds);
				}
			},

			prepareLogbookMap: function () {
				var self = this;
				var map = this.map;
				if (!map.getPane('fakeTripPane')) {
					map.createPane('fakeTripPane').style.zIndex = 399; // fake trips go to their own pane just below overlayPane (z-index 400), so they stay under regular trips
				}
				self.onEachFeature = function (feat, layer) {
					if (feat.properties.type === 'trip' || feat.properties.type === 'trip-fake') {
						var fake = feat.properties.type === 'trip-fake' ? self.geoJsonStyleOpts['trip-fake'] : null;
						if (feat.geometry.type === 'LineString') { // If width is set to 0, a trip is sent as a LineString
							var coords = feat.geometry.coordinates;
							var latLngs = [];

							for (var c in coords) {
								var latLng = [coords[c][1], coords[c][0]];
								latLngs.push(latLng);
								self.geoBounds.extend(latLng);
							}

							var polyline = L.polyline(latLngs, L.extend({
								color: feat.properties.color,
								weight: $("#lineWidth_value").text() != "0" ? $("#lineWidth_value").text() : "5" || "5",
							}, fake && {opacity: fake.opacity, dashArray: fake.dashArray, pane: 'fakeTripPane'}));

							self.clusters['geozone-circle'].addLayer(polyline);
						} else if (feat.geometry.type === 'MultiPolygon') {
							feat.geometry.coordinates.forEach(function(polygon) {
								var polygonLatLngs = polygon.map(function(coord) {
									return coord.map(function(latLon) {
										return [latLon[1], latLon[0]];
									});
								});

								var polygonLayer = L.polygon(polygonLatLngs, L.extend({
									color: feat.properties.color,
									weight: 2,
									fillOpacity: 1
								}, fake && {opacity: fake.opacity, fillOpacity: fake.opacity, dashArray: fake.dashArray, pane: 'fakeTripPane'}));

								self.geoBounds.extend(polygonLayer.getBounds());
								self.clusters['geozone-circle'].addLayer(polygonLayer);
							});
						}
					} else if (feat.geometry.type === 'Point') {
						if (self.creators.createFeature(self, feat)) {
							feat.removeFromLayer = true;
							var pt = feat.properties['type'];
							if ((pt != 'POI')
								|| (self.opts.extendBoundsToPOI == true)) {
								self.geoBounds.extend([
									feat.geometry.coordinates[1],
									feat.geometry.coordinates[0]]);
							}
						}
					} else if (feat.geometry.type === 'GeometryCollection' && feat.properties.type === 'gz') {
						self.creators.createGeoPoint(self, feat);
					}
				};

				self.onRightClickShowInsertPoi();
			},

			onRightClickShowInsertPoi: function () {
				var self = this;
				self.map.on('contextmenu', function (e) {
					var lat = e.latlng.lat;
					var lng = e.latlng.lng;
					if (self.poiMenu != null) self.map.closePopup();
					self.poiMenu = L.popup()
						.setLatLng(e.latlng)
						.setContent(self.createInsertGeozoneBox(lat, lng, Ptx.options.cId))
						.openOn(self.map);
					Ptx.fn.initShowModal($('#poiMenu-' + self.getJQueryIdSafeCoords(lat, lng)));
				});
			},


			/** @see maps/base#markerShowLabels */
			markerShowLabels: function (type, show) {
				var self = this;
				self.base(type, show);
				var items;
				if (type == "ALL") {
					items = $('.vehicle-marker');
				} else {
					items = $('.vehicle-marker-type-' + type);
				}
				items.each(function () {
					var ctx = $(this);
					var title = $('.title', ctx);

					if (self.showLabels) {
						title.removeClass('hidden');
					} else {
						title.addClass('hidden')
					}
				});

			},
			/** @see maps/base#forceRefreshMap */
			forceRefreshMap: function () {
//		 google.maps.event.trigger(self.map, 'idle');
			},

			/** @see maps/base#createPoint */
			createPoint: function (element) {
				var car = {
					ico: element.objectType,
					state: "",
					color: element.color,
					info: "",
					name: element.name,
					type: "car",
					tz: "Europe/Prague"
				};
				this.creators.createPoint(this, car, element.latLon);
			}
		});
